import api from "./api";

const ScheduleService = {
    getScheduleByWeek: (isoWeek) => api.get(`/api/schedule/${isoWeek}/`),
    getHolidaysByYear: (year) => api.get(`/api/holidays/${year}/`),
};

export default ScheduleService;
